import { Button, Modal } from '@leagueplatform/genesis-core';
import React, { useState } from 'react';
import { useIntl } from '@leagueplatform/locales';
import { MobileNavDrawer } from './mobile-nav-drawer.component';
import { NavItem, UserSettingsLinksConfig } from '../nav-types.types';
import { HeaderNavItem } from '../header-nav-link.component';

export const MobileNavBar = ({
  navLinks,
  userSettingsLinks,
  logo,
}: {
  navLinks: NavItem[];
  userSettingsLinks: UserSettingsLinksConfig[];
  logo?: React.ReactElement;
}) => {
  const [menuOpen, setMenuOpen] = useState<boolean>(false);
  const { formatMessage } = useIntl();

  return (
    <>
      <HeaderNavItem
        css={{
          margin: '$half',
        }}
      >
        {logo}
      </HeaderNavItem>

      <Modal.Root
        open={menuOpen}
        onOpenChange={() => {
          setMenuOpen((previous) => !previous);
        }}
      >
        <Modal.Trigger>
          <HeaderNavItem css={{ marginLeft: 'auto' }}>
            <Button
              icon="interfaceMenu"
              hideLabel
              quiet
              priority="tertiary"
              size="large"
              css={{
                margin: '$half $quarter',
                color: '$onSurfaceIconPrimary',
              }}
              aria-controls="user_dropdown_menu"
            >
              {formatMessage({ id: 'STR_OPEN_MENU' })}
            </Button>
          </HeaderNavItem>
        </Modal.Trigger>
        <Modal.Content
          id="user_dropdown_menu"
          layout="right"
          css={{
            '.GDS-modal': { maxWidth: 335 },
            '.GDS-modal-content': { paddingLeft: '$one' },
          }}
        >
          <MobileNavDrawer
            closeModal={() => setMenuOpen(false)}
            navLinks={navLinks}
            userSettingsLinks={userSettingsLinks}
          />
        </Modal.Content>
      </Modal.Root>
    </>
  );
};
